<template>
  <v-dialog :value="true" max-width="290">
    <v-card>
      <v-card-title class="headline">Mudar de pacote</v-card-title>
      <v-card-text class="pt-2">
        Todos itens ligados a <b>{{ actualJoined.fundraising.name }}</b> vão ser transferidos para a nova arrecadação e o participante não vai mais estar ligado à <b>{{ actualJoined.fundraising.name }}</b>.
      </v-card-text>
      <v-card-text class="pt-1">
        <v-alert type="error" v-if="errorMessage" class="mb-6">{{ errorMessage }}</v-alert>
        <v-form ref="form" @submit.prevent>
          <v-autocomplete
            label="Nova Arrecadação *"
            v-model="fields.joined_to.value"
            :rules="[...fields.joined_to.rules, ...fields.joined_to.apiErrors]"
            :items="joinedsOptions"
            @input="fields.joined_to.apiErrors = []"
            outlined dense
          ></v-autocomplete>
        </v-form>
      </v-card-text>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn color="default" :disabled="saving" text @click="$emit('canceled')">
          Cancelar
        </v-btn>
        <v-btn color="success" :disabled="saving" :loading="saving" text @click="saveItem()">
          Salvar
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import axios from 'axios'
import { mapMutations } from 'vuex'

export default {
  name: 'JoinedChange',
  props: {
    joineds: {
      required: true,
      type: Array
    },
    id: {
      required: true,
      type: [String, Number]
    }
  },
  data: () => ({
    saving: false,
    fields: {
      joined_to: {
        value: null,
        rules: [
          v => !!v || 'A nova arrecadação é obrigatória'
        ],
        apiErrors: []
      }
    },
    errorMessage: null
  }),
  computed: {
    actualJoined () {
      return this.joineds.find(j => j.joined_id === this.id)
    },
    joinedsOptions () {
      const joinedsOptions = []
      for (const index in this.joineds) {
        const joined = this.joineds[index]
        if (joined.joined_id !== this.id) {
          joinedsOptions.push({ value: joined.joined_id, text: joined.fundraising.name })
        }
      }
      return joinedsOptions
    },
    apiData () {
      return {
        joined: {
          from: this.id,
          to: this.fields.joined_to.value
        }
      }
    }
  },
  methods: {
    ...mapMutations(['SET_SNACKBAR']),
    saveItem () {
      let vue = this
      vue.saving = true

      if (vue.$refs.form.validate()) {
        axios('joineds/change', {
          method: 'post',
          data: vue.apiData
        })
          .then(response => {
            vue.saving = false
            vue.SET_SNACKBAR({ text: 'Forma de pagamento editada' })
            vue.$emit('edited')
          })
          .catch(() => {
            vue.SET_SNACKBAR({ text: 'Houve um erro ao processar seu pedido, por favor tente novamente' })
            vue.saving = false
            vue.$emit('error')
          })
      } else {
        vue.saving = false
      }
    }
  },
  watch: {
    id () {
      this.fields.joined_to.value = null
    }
  }
}
</script>
